import { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import { useMapStore } from '@/stores/mapStore';
import type { LineStringGeometry } from '@/types/map';

export default function RoutePolylines() {
  const map = useMap();
  const routeLines = useMapStore((s) => s.routeLines);
  const layerRef = useRef<L.LayerGroup>(L.layerGroup());

  useEffect(() => {
    layerRef.current.addTo(map);
    return () => {
      layerRef.current.remove();
    };
  }, [map]);

  useEffect(() => {
    layerRef.current.clearLayers();

    routeLines.forEach((feature) => {
      const geom = feature.geometry as LineStringGeometry;
      const coords = geom.coordinates.map(([lon, lat]) => [lat, lon] as [number, number]);
      const props = feature.properties;

      L.polyline(coords, {
        color: props.stroke || '#3b82f6',
        weight: props.stroke_width || 4,
        opacity: props.stroke_opacity || 0.8,
      }).addTo(layerRef.current);
    });
  }, [routeLines]);

  return null;
}
